var _style, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 140 145.43",
    style: {
      enableBackground: "new 0 0 140 145.43"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#1da193;}\r\n\t.st2{fill:#1da193;}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#1da193;}\r\n\t.st4{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 140,
    height: 145.43
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4402",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7579",
    className: "st1",
    d: "M70.95,133.05c31.56,0,57.14,2.77,57.14,6.19s-25.58,6.19-57.14,6.19s-57.14-2.77-57.14-6.19 S39.39,133.05,70.95,133.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7580",
    className: "st1",
    d: "M98.79,9.99c4.07-8.68,14.4-12.41,23.08-8.34c4.37,2.05,7.69,5.82,9.16,10.42 c5.07,0.25,9.04,4.47,8.97,9.54c0,0.49-51.43,0.34-51.43,0c-0.03-7.91,2.68-11.69,8.94-11.69C97.94,9.91,98.37,9.94,98.79,9.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7581",
    className: "st1",
    d: "M59.52,15.16C53.64,2.63,38.72-2.77,26.18,3.11c-6.31,2.96-11.1,8.41-13.23,15.05 C5.63,18.51-0.1,24.6,0,31.93c0.01,0.71,74.29,0.49,74.29,0c0.04-11.42-3.88-16.88-12.91-16.88 C60.75,15.06,60.14,15.09,59.52,15.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7582",
    className: "st2",
    d: "M28.33,136.24l-6.65-52.64c-0.34-2.22,1.18-4.3,3.4-4.64c0.24-0.04,0.49-0.05,0.73-0.05h56.07 L28.33,136.24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7583",
    className: "st3",
    d: "M29.75,136.06L23.1,83.41c-0.22-1.46,0.78-2.83,2.24-3.05c0.16-0.02,0.32-0.03,0.48-0.03H53.3 c0.79,0.02,1.45-0.6,1.47-1.39s-0.6-1.45-1.39-1.47c-0.03,0-0.05,0-0.08,0H25.81c-3.02-0.08-5.53,2.3-5.61,5.31 c-0.01,0.33,0.01,0.66,0.06,0.99l6.65,52.64c0.1,0.78,0.81,1.34,1.6,1.24C29.29,137.56,29.85,136.84,29.75,136.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7584",
    className: "st2",
    d: "M84.41,64.4h-6.5c0.2,0.78,0.3,1.59,0.3,2.4v8.72c0,5-3.68,9.1-8.19,9.1s-8.19-4.09-8.19-9.1 v-8.72c0-0.81,0.1-1.62,0.3-2.4h-6.5c-5,0-6.68-3.3-3.71-7.33l12.71-17.3c2.96-4.03,7.81-4.03,10.78,0l12.72,17.3 C91.09,61.1,89.42,64.4,84.41,64.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7587",
    className: "st4",
    d: "M28.33,136.24h84.11l10.71-60.8H82.36c-2.93,0.17-5.67,1.53-7.56,3.78L67.24,89.3H43.77 c-2.73,0.1-5.07,1.97-5.78,4.61L28.33,136.24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7588",
    className: "st3",
    d: "M67.24,87.87H43.77c-3.39,0.13-6.29,2.44-7.17,5.72l-4.49,19.66 c-0.16,0.77,0.33,1.53,1.1,1.69c0.76,0.16,1.5-0.31,1.68-1.06l4.49-19.66c0.53-2,2.31-3.42,4.38-3.5h23.47 c0.79-0.02,1.41-0.68,1.39-1.47C68.61,88.5,67.99,87.89,67.24,87.87L67.24,87.87z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7589",
    className: "st3",
    d: "M121.45,76.87H82.36c-0.79-0.02-1.41-0.68-1.39-1.47c0.02-0.76,0.63-1.37,1.39-1.39h40.79 c0.79,0,1.43,0.64,1.43,1.43c0,0.08-0.01,0.17-0.02,0.25l-10.71,60.8c-0.12,0.68-0.71,1.18-1.41,1.18H28.33 c-0.79-0.02-1.41-0.68-1.39-1.47c0.02-0.76,0.63-1.37,1.39-1.39h82.91L121.45,76.87z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7590",
    className: "st2",
    d: "M84.25,130.57l2.29-13.03h23.47l-2.3,13.03H84.25z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument);
export default __webpack_public_path__ + "static/media/icon_document.4e0b28a5f85d2afea733cdd27513ebe9.svg";
export { ForwardRef as ReactComponent };